/* global Blockly */
import React from 'react';
import {getFormsFromContext} from "../../../v1/helpers";

function defineBlock(context) {
    const forms = getFormsFromContext(context);

    return {
        init: function () {
            this.appendDummyInput()
                .appendField("sync form")
                .appendField(new Blockly.FieldDropdown(forms), "FORMSLUG");
            this.appendStatementInput('THEN').appendField('then');
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.APP_ACTIONS_HUE);
            this.setTooltip('Reset a form or a screen in the application.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#app-actions");
        }
    }
}

function defineGenerators() {
    return {
        "JavaScript": function (block) {
            let formSlug = block.getFieldValue('FORMSLUG');
            let formFields = formSlug.split("<<<>>>");
            let formDataGenyId = formFields[0];
            let pageId = formFields[1];

            let innerBlockCode = Blockly.JavaScript.statementToCode(block, 'THEN');
            let code = `
                actionsModule.executeActionWithCallback({
                    action: {
                        actionType: "sync"
                    },
                    formDataGenyId: "${formDataGenyId || pageId}",
                }, function() {
                    ${innerBlockCode}
                });\n`;

            return code;
        }
    }
}

const Sync = function (props) {
    let name = "snap_action_sync_V3";
    Sync.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);

    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (!getFormsFromContext(props.context).length) {
        return null;
    }

    return (
        <block type={name}></block>
    );
};

export default Sync;
